import React, { Component } from "react";

import { withStyles } from '@mui/styles';
import styles from './index.styles';
import { withTranslation } from 'react-i18next';
import {
  Table, TableBody, TableCell, TableHead, TableRow, Tooltip, List, ListItem, ListItemIcon, ListItemText, TableSortLabel, IconButton
} from "@mui/material";
import { Box } from "@mui/system";
import InfiniteScroll from 'react-infinite-scroll-component';
import PropTypes from "prop-types";
import FilterAltOffOutlinedIcon from '@mui/icons-material/FilterAltOffOutlined';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';

const legend = [
  { color: "linear-gradient(155deg, rgb(212,209,0) 0%, rgb(255,255,189) 90%)", label: "Assigned" },
  { color: "linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(4, 144, 243) 90%)", label: "Hold" },
  { color: "linear-gradient(155deg, rgb(23,166,0) 0%, rgb(196,255,189) 90%)", label: "Stocked" },
  { color: "linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(249, 27, 27) 90%)", label: "Deactivate" },
];

const DEVICE_TYPE = {
  Assigned: '8f9c8e02-b9ee-4f29-aeea-670cef022663',
  Stocked: '4ee90c0f-d4c3-4d53-8014-d7eac4ea2894',
  Hold: '45593c2c-fc8c-4bf0-854e-e2bf759b7788',
  Deactivate: '4f666da5-bfe0-4fb5-ad77-b92103881220',
};

let FilterObj = {
  sortOrder: 'desc',
  sortColumn: 'created_on',
  tableName: ''
}

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  if (array && array.length <= 0) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}
class EnhancedTableHead extends React.Component {
  createSortHandler = (property, field) => event => {
    this.props.onRequestSort(event, property, field);
  };

  render() {
    const {
      order,
      orderBy,
      sortId,
      t
    } = this.props;
    const rows = [
      { id: "name", numeric: false, disablePadding: false, label: t('Task.Patient'), padding: '8px', field: 'name' },
      { id: "stock_code", numeric: false, disablePadding: false, label: t('Unplugged.SearchPopup.StockCode'), padding: '8px', field: 'stock_code' },
      { id: "bin_id", numeric: false, disablePadding: false, label: t('Unplugged.BIN'), padding: '8px', field: 'bin_id' },
      { id: "bin_size", numeric: false, disablePadding: false, label: t('Unplugged.BinSize'), padding: '8px', field: 'bin_size' },
    ];

    return (
      <TableHead>
        <TableRow>
          <TableCell style={{ padding: '0px', border: 'none' }}></TableCell>
          {rows.map(row => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                style={{ padding: row.padding, color: 'grey' }}
              >
                <Tooltip
                  title={t("Global.Label.Filter.Sort")}
                  placement={"right"}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === row.field && sortId === row.id}
                    direction={order}
                    onClick={this.createSortHandler(row.id, row.field)}
                  >
                    {row.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);
export class PreAssignmentLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPagePending: 10,
      hasMore: true,
      BinStatus: [],
      BoxID: this.props.BoxID,
      order: "desc",
      orderBy: "created_on",
      isFiltered: false,
      status: 'All'
    }
  }

  componentDidMount() {
    this.getGridData(this.state.BoxID, 'All');
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.BoxID !== prevProps.BoxID) {
      this.setState({ BoxID: this.props.BoxID });
      this.getGridData(this.props.BoxID, 'All');
    }
    if (this.props.makeAPICall !== prevProps.makeAPICall && this.props.makeAPICall) {
      this.setState({ BoxID: this.props.BoxID });
      this.reloadGrid();
    }
  }

  getGridData = (boxId, status) => {
    fetch(process.env.REACT_APP_BASEURL + `pre-assignment/gridByBox/${boxId}/${status}?tableName=${FilterObj.tableName}&sortColumn=${FilterObj.sortColumn}&sortOrder=${FilterObj.sortOrder}`, {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
      },
    })
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((bins) => {
        let deactivatedBins;
        let _binStatus = JSON.parse(bins);
        if (_binStatus && _binStatus[0] && _binStatus[0].disabled_bins) {
          deactivatedBins = _binStatus[0].disabled_bins.toString().split(',');
          _binStatus = _binStatus.map(item => {
            if (deactivatedBins.includes(item.bin_id)) {
              item.type_id = DEVICE_TYPE.Deactivate
              return item;
            } else {
              return item;
            }
          })
          if (status === 'Deactivate') {
            _binStatus = _binStatus.filter(item => item.type_id === DEVICE_TYPE.Deactivate)
          } else if (status !== 'All') {
            _binStatus = _binStatus.filter(item => item.type_id !== DEVICE_TYPE.Deactivate)
          }
        }
        this.setState({ BinStatus: _binStatus });
      });
  }

  handleStockCodeClick = (event, item) => {
    event && event.preventDefault();
    this.props.getPrescriptionDetails(item.bin_id, item.pm_id);
  }

  getKeyByValue = (targetValue) => {
    for (const key in DEVICE_TYPE) {
      if (DEVICE_TYPE.hasOwnProperty(key) && DEVICE_TYPE[key] === targetValue) {
        return key;
      }
    }
    return ""
  }

  getColorByValue = (label) => {
    return legend.filter((ele) => ele.label === label)[0].color
  }

  fetchMoreData = (type) => {
    const { BinStatus } = this.props;
    const _recentOrders = BinStatus.length && BinStatus;
    if (type === 'pending') {
      let total = 0;
      total = _recentOrders.length;
      if (total > 0) {
        this.setState({ total: this.state.total + total, rowsPerPagePending: this.state.rowsPerPagePending + 10 });
      } else {
        this.setState({ hasMore: false });
      }
    }
  }

  handleStatusClick = (e, label) => {
    e && e.preventDefault();
    this.setState({ isFiltered: true, status: label });
    this.getGridData(this.state.BoxID, label)
  }

  handleRequestSort = (event, property, field) => {
    const { BoxID, status } = this.state;
    const orderBy = property;
    let order = "desc";
    if (this.state.orderBy === orderBy) {
      order = this.state.order === "asc" ? "desc" : "asc";
    } else if (this.state.order === order) {
      order = "asc";
    } else {
      order = "desc";
    }
    this.setState({ order, orderBy, sortId: property });
    FilterObj.sortOrder = order;
    FilterObj.sortColumn = field;
    FilterObj.tableName = property === 'name' ? 'customers' : '';
    this.getGridData(BoxID, status)
  };

  clearFilters = () => {
    FilterObj.sortOrder = 'desc';
    FilterObj.sortColumn = 'created_on';
    FilterObj.tableName = '';
    this.getGridData(this.state.BoxID, 'All');
    this.setState({ isFiltered: false, status: 'All' });
  }

  reloadGrid = () => {
    FilterObj.sortOrder = 'desc';
    FilterObj.sortColumn = 'created_on';
    FilterObj.tableName = '';
    this.setState({ isFiltered: false, status: 'All' })
    this.props.getAvailableBinsCount(this.state.BoxID);
    this.getGridData(this.state.BoxID, 'All');
  }

  render() {
    const { t, BoxID } = this.props;
    const { BinStatus, isFiltered } = this.state;
        const _recentOrders = BinStatus.length && BinStatus;
    const isFilterDisabled = BinStatus.length ? isFiltered ? false : true : true;
    return (
      <Box
        component='div'
        sx={{
          width: '100%',
          textAlign: 'center',
          mt: '2%',
        }}
      >
        <div style={{ width: '100%', display: 'flex', padding: '20px', lineHeight: 3, flexDirection: 'column' }}>
          <div>
            <div style={{ textAlign: 'center', display: 'flex', justifyContent: "space-between", alignItems: "center" }}>
              <label style={{ color: '#000', fontSize: '1.2rem', fontWeight: 450, flex: '1' }}>
                {t('Fastlan.Component.RecentOrdersTitle')}
              </label>
              <Tooltip key="reload-grid" title={t("Reload")}>
                <IconButton onClick={() => this.reloadGrid()} sx={{ backgroundColor: "transparent" }}>
                  <RefreshRoundedIcon />
                </IconButton>
              </Tooltip>
              <Tooltip key="clear-filters" title={t("Report.Assign.ClearFiltersTooltip")}>
                <IconButton disabled={isFilterDisabled} onClick={() => this.clearFilters()} sx={{ backgroundColor: "transparent" }}>
                  <FilterAltOffOutlinedIcon />
                </IconButton>
              </Tooltip>
            </div>
            <div style={{ textAlign: 'left' }}>
              <InfiniteScroll
                dataLength={this.state.rowsPerPagePending}
                next={() => this.fetchMoreData('pending')}
                hasMore={this.state.hasMore}
                height={410}
                endMessage={
                  <p style={{ textAlign: 'center' }}>
                    <b>{t("Console.YouHaveSeenIt")}</b>
                  </p>
                }>
                <Table>
                  <EnhancedTableHead
                    order={FilterObj.sortOrder}
                    orderBy={FilterObj.sortColumn}
                    sortId={this.state.sortId}
                    onRequestSort={this.handleRequestSort}
                  />
                  <TableBody>
                    {_recentOrders ? stableSort(_recentOrders, getSorting(FilterObj.sortOrder, FilterObj.sortColumn)).map((item, index) => {
                      const title = item && item.type_id && this.getKeyByValue(item.type_id);
                      const bgColor = title && this.getColorByValue(title)
                      return (
                        <TableRow>
                          <TableCell style={{ padding: '5px 5px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none' }}>
                            <Tooltip key={index} title={title}>
                              <span style={{ background: bgColor, border: '1px solid #888', borderRadius: '50%', height: '20px', width: '20px' }}>
                                &nbsp;
                              </span>
                            </Tooltip>
                          </TableCell>
                          <TableCell style={{ padding: '5px 5px' }}>{item.name}</TableCell>
                          <TableCell style={{ padding: '5px 5px' }}>
                            <a href='' title="View Pick up by" style={{ fontWeight: 500, textDecoration: 'none ', fontSize: '1rem' }} onClick={(event) => this.handleStockCodeClick(event, item)}>{item.stock_code}</a>
                          </TableCell>
                          <TableCell style={{ padding: '5px 5px' }}>{item.bin_id}</TableCell>
                          <TableCell style={{ padding: '5px 5px' }}>{item.bin_size}</TableCell>
                        </TableRow>
                      )
                    }) :
                      <TableRow>
                        <TableCell style={{ borderBottom: 'none' }}></TableCell>
                        <TableCell colSpan={4} style={{ borderBottom: 'none', textAlign: 'center' }}>{t("Unplugged.NoDataFound")}</TableCell>
                      </TableRow>}
                  </TableBody>
                </Table>
              </InfiniteScroll>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <List sx={{ display: 'flex', flexDirection: 'row' }}>
              {legend.map((value) => {
                return (
                  <ListItem disablePadding onClick={(e) => this.handleStatusClick(e, value.label, BoxID)} sx={{ cursor: 'pointer', margin: '0 10px' }}>
                    <ListItemIcon>
                      <span style={{ background: value.color, height: '20px', width: '20px', border: '1px solid #888', borderRadius: '50%' }}>&nbsp;</span>
                    </ListItemIcon>
                    <ListItemText primary={value.label} />
                  </ListItem>
                );
              })}
            </List>
          </div>
        </div>
      </Box>
    )
  }
}

export default withStyles(styles)(withTranslation()(PreAssignmentLayout));


// WEBPACK FOOTER //
// ./src/components/unplugged-assign-prescriptions/pre-assignment-layout.js